import Papa from "papaparse";
import * as yup from "yup";

import { rowSchema } from "./rowSchema";

export const MAX_FILE_SIZE_BYTE = 100 * 1024;
export const MAX_ROW_NUM = 1000;

const validateRowAndReturnErrors = (row: Record<string, string>, lineNum: number) => {
  try {
    rowSchema.validateSync(row, { abortEarly: false });
    return null;
  } catch (error) {
    if (error instanceof yup.ValidationError) {
      return error.errors;
    }
  }
};

const prependLineNumber = (errors: string[], lineNum: number) => {
  return errors.map((error) => `Line ${lineNum}: ${error}`);
};

export const validateCsv = (csv: File): Promise<string[] | null> => {
  if (csv.size > MAX_FILE_SIZE_BYTE) {
    return Promise.reject([`CSV file exceeds maximum limit of ${MAX_FILE_SIZE_BYTE / 1000} KB`]);
  }

  return new Promise((resolve, reject) => {
    Papa.parse<Record<string, string>>(csv, {
      complete: (results) => {
        const errors: string[] = [];
        const data = results.data || [];

        if (data.length === 0) reject(["Error: Empty CSV"]);
        if (data.length > MAX_ROW_NUM) reject([`Error: CSV cannot exceed ${MAX_ROW_NUM} rows`]);

        data.forEach((row, index) => {
          const lineNum = index + 2; // header is line 1, data starts at line 2
          const rowErrors = validateRowAndReturnErrors(row, lineNum);
          if (rowErrors) errors.push(...prependLineNumber(rowErrors, lineNum));
        });

        errors.length > 0 ? reject(errors) : resolve(null);
      },
      error: () => {
        reject(["Error parsing csv."]);
      },
      header: true,
      skipEmptyLines: true,
    });
  });
};
